import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './common/common.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'          // swiper5 的引用方式
import router from './router'
import Cookies from "js-cookie";
import axios from "axios";

// axios.defaults.baseURL = 'https://api-wx.qtthtech.com'
// axios.defaults.baseURL = 'http://testapi-wx.qtthtech.com'
// axios.defaults.baseURL = 'http://109.244.44.219:8087'

axios.defaults.withCredentials = true
Vue.use(router)
Vue.use(ElementUI)
import {outLink} from '@/common/outLink.js'
router.beforeEach((to,from,next)=>{
  document.title = to.meta.title //切换路由改变页面标题
  let postfix1 = "";

  if (Object.keys(to.query).length > 1) {
    let postfix = to.fullPath.split("&s=");
    // if (postfix.length > 1) {
    postfix1 = postfix[0];
    // console.log(postfix1, "postfix1");
    // }
  } else if (to.query.s) {
    postfix1 = to.path;
  } else {
    postfix1 = to.fullPath;
  }

  // console.log(postfix1,'postfix1');
  // const whether = to.query.s ? to.query.s : "";
  // // console.log(whether,'whether');
  // if (whether) {
  //   // if (localStorage.getItem(whether)) {
  //   //   location.reload();
  //   // }
  //   if (whether == "17173") {
  //     localStorage.removeItem("shop9i173");
  //   } else if (whether == "9i173") {
  //     localStorage.removeItem("shop17173");
  //   }
  //   localStorage.setItem(`shop`+whether, whether);
  //   next({
  //     path: postfix1,
  //   });
  //   // next()
  //   // console.log(to);

  //   return;
  // }
  next()
})

// 添加响应拦截器
// axios.interceptors.response.use(  function(response) {
//   if(response.status == 200){
//     return Promise.resolve(response)
//   }else{
//     return response
//   }
// }, function (err) {
//   if (err && err.response) {
//     switch (err.response.status) {
//       case 400:
//         Vue.prototype.$message.error('当前系统开了小差，请重试！')
//         break
//       case 402:
//         window.location.href='/'
//         break
//     }
//   }else{
//     Vue.prototype.$message.error('当前系统开了小差，请重试！')
//   }
//   return Promise.reject(err)
// })


Vue.config.productionTip = false

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'userInfo') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
